export const PLAIN_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png'];
export const IMAGE_MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
export const IMAGE_UPLOAD_ACCEPT = [
  ...IMAGE_MIME_TYPES,
  PLAIN_IMAGE_EXTENSIONS,
].join(', ');
